

import pcRouter from "@/views/pc/template.vue";

// PC 端路由 
const main = {
	path: "/pc",
	name: "pc",
	component: pcRouter,
	children: [{
		path: "login",
		name: "login-pc",
		component: () => import("@/views/pc/login/login"),
		meta: {
			title: "登录",
		},
	},
	{
		path: "register",
		name: "register-pc",
		component: () => import("@/views/pc/login/register"),
		meta: {
			title: "注册",
		},
	},
	{
		path: "forgetPwd",
		name: "forgetPwd-pc",
		component: () => import("@/views/pc/login/forgetPwd"),
		meta: {
			title: "重置密码",
		},
	},
	{
		path: "resetPwd",
		name: "resetPwd-pc",
		component: () => import("@/views/pc/login/resetPwd"),
		meta: {
			title: "重置密码",
		},
	},
	{
		path: "home",
		name: "home-pc",
		component: () => import("@/views/pc/home/index"),
		meta: {
			title: "首页",
		},
	},
	{
		path: "aiIndex",
		name: "aiIndex-pc",
		component: () => import("@/views/pc/aiIndex/index"),
		meta: {
			title: "AI量化策略",
		},
	},
	{
		path: "grade",
		name: "grade-pc",
		component: () => import("@/views/pc/aiIndex/grade"),
		meta: {
			title: "AI等级规则",
		},
	},
	{
		path: "trade",
		name: "trade-pc",
		component: () => import("@/views/pc/trade/index"),
		// 1=期权合约2=现货
		props: { type: '1' }, // 固定参数
		meta: {
			title: "期权",
		},
	},
	{
		path: "contract",
		name: "contract-pc",
		component: () => import("@/views/pc/trade/index"),
		props: { type: '3' }, // 固定参数
		meta: {
			title: "合约",
		},
	},
	{
		path: "spotGoods",
		name: "spotGoods-pc",
		component: () => import("@/views/pc/trade/index"),
		props: { type: '2' }, // 固定参数
		meta: {
			title: "现货",
		},
	},
	{
		path: "c2cIndex",
		name: "c2cIndex-pc",
		component: () => import("@/views/pc/c2cIndex/index"),
		meta: {
			title: "C2C交易",
		},
	},
	{
		path: "documentary",
		name: "documentary-pc",
		component: () => import("@/views/pc/documentary/index"),
		meta: {
			title: "跟单",
		},
	},
	{
		path: "documentaryRecord",
		name: "documentaryRecord-pc",
		component: () => import("@/views/pc/documentary/list"),
		meta: {
			title: "我的跟单",
		},
	},
	{
		path: "followOrderDetails",
		name: "followOrderDetails-pc",
		component: () => import("@/views/pc/documentary/details"),
		meta: {
			title: "跟单详情",
		},
	},
	{
		path: "borrowMoney",
		name: "borrowMoney-pc",
		component: () => import("@/views/pc/borrowMoney/index"),
		meta: {
			title: "DeFi借幣",
		},
	},
	{
		path: "portfolio",
		name: "portfolio-pc",
		component: () => import("@/views/pc/portfolio/index"),
		meta: {
			title: "投資組合",
		},
	},
	{
		path: "portfolioOrder",
		name: "portfolioOrder-pc",
		component: () => import("@/views/pc/portfolio/list"),
		meta: {
			title: "投資組合-投資訂單",
		},
	},
	{
		path: "portfolioDetails",
		name: "portfolioDetails-pc",
		component: () => import("@/views/pc/portfolio/details"),
		meta: {
			title: "投資組合-详情",
		},
	},
	{
		path: "quotes",
		name: "quotes-pc",
		component: () => import("@/views/pc/quotes/index"),
		meta: {
			title: "加密貨幣行情",
		},
	},
	{
		path: "news",
		name: "news-pc",
		component: () => import("@/views/pc/news/index"),
		meta: {
			title: "新聞資訊",
		},
	},
	{
		path: "activityIndex",
		name: "activityIndex-pc",
		component: () => import("@/views/pc/activityIndex/index"),
		meta: {
			title: "活動大廳",
		},
	},
	{
		path: "activityVip",
		name: "activityVip-pc",
		component: () => import("@/views/pc/activityIndex/vip"),
		meta: {
			title: "活動大廳-vip",
		},
	},
	{
		path: "assetsIndex",
		name: "assetsIndex-pc",
		component: () => import("@/views/pc/assetsIndex/index"),
		meta: {
			title: "资产中心",
		},
	},
	{
		path: "currencyPurchase",
		name: "currencyPurchase-pc",
		component: () => import("@/views/pc/currencyPurchase/index"),
		meta: {
			title: "快捷买币",
		},
	},
	{
		path: "buyingCoinsOrder",
		name: "buyingCoinsOrder-pc",
		component: () => import("@/views/pc/buyingCoinsOrder/index"),
		meta: {
			title: "歷史訂單",
		},
	},
	{
		path: "transferLog",
		name: "transferLog-pc",
		component: () => import("@/views/pc/transferLog/index"),
		meta: {
			title: "实名认证",
		},
	},
	{
		path: "invitation",
		name: "invitation-pc",
		component: () => import("@/views/pc/invitation/index"),
		meta: {
			title: "分享好友",
		},
	},
	{
		path: "change",
		name: "change-pc",
		component: () => import("@/views/pc/change/index"),
		meta: {
			title: "安全中心",
		},
	},
	{
		path: "withdrawDeposit",
		name: "withdrawDeposit-pc",
		component: () => import("@/views/pc/withdrawDeposit/index"),
		meta: {
			title: "提币",
		},
	},
	{
		path: "deposit",
		name: "deposit-pc",
		component: () => import("@/views/pc/deposit/index"),
		meta: {
			title: "充币",
		},
	},
	{
		path: "exchange",
		name: "exchange-pc",
		component: () => import("@/views/pc/exchange/index"),
		meta: {
			title: "闪兑",
		},
	},
	{
		path: "UOrder",
		name: "UOrder-pc",
		component: () => import("@/views/pc/UOrder/index"),
		meta: {
			title: "账户历史记录",
		},
	},
	{
		path: "article",
		name: "article-pc",
		component: () => import("@/views/pc/article/index"),
		meta: {
			title: "文章",
		},
	},
	]
}

export default main